<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Kembar IMEI / SN</h5>
            </template>
            <b-table bordered hover show-empty sticky-header :style="`max-height: ${window.tableHeight}`"
                :busy="isBusy"
                :items="dataKembarImei" 
                :fields="fields"
                responsive class="mb-0">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data imei yang kembar.
                </template>
                <template v-slot:cell(total)="row">
                    <div class="text-right no-wrap">{{$helper.addThousandSeparator(row.item.total)}} </div>
                </template>
            </b-table>
        </b-card>
    </div>
</template>

<script>
export default {
    name: 'kembar-imei',
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            fields: [
                { key: "imeiSn", label: "Imei SN", sortable:true},
                { key: "total", label: "Total", sortable:true},
                { key: "faktur", label: "Faktur", sortable: true}
            ],
            dataKembarImei: [],
            window: {
                tableHeight: 0,
            },
        }
    }, 
    
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 1

            let getGadaiKembarImei = this.$axios.get("gadai/kembar-imei-sn/").then(response => {
                this.dataKembarImei = response.data
            })

            Promise.all([getGadaiKembarImei]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy(){
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        handleResize() {
            let windowHeight = window.innerHeight
            let tableHeight = windowHeight - (55+46+50+100+51)
            this.window.tableHeight = tableHeight+'px'
        },

    },
    created(){
        this.init()
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    }
}
</script>
